import { useCallback, useRef, useState } from 'react';
export const useSingleSubmit = (submit)=>{
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);
    const submitOnce = useCallback(async ()=>{
        if (isSubmittingRef.current) {
            return;
        }
        isSubmittingRef.current = true;
        setIsSubmitting(true);
        try {
            await submit();
        } catch (error) {
            console.error(error);
        }
        isSubmittingRef.current = false;
        setIsSubmitting(false);
    }, [
        submit
    ]);
    return {
        submitOnce,
        isSubmitting
    };
};

//# sourceMappingURL=use-single-submit.js.map